export const getMarketOptions = (marketTypes, dict, sportId) => {
    return marketTypes.map((marketType, index) => {
        const idLive = marketType.idLive;
        const idPreLive = marketType.idPreLive;
        return {
            value: `${idLive},${idPreLive}`,
            label: dict[idLive]
                || dict[idPreLive]
                || dict[`${sportId}_${idLive}`]
                || dict[`${sportId}_${idPreLive}`]
                || idLive,
            selected: index === 0
        };
    });
};
//# sourceMappingURL=getMarketOptions.js.map